import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
var DigitalEditingUniques = function DigitalEditingUniques() {
  return /*#__PURE__*/React.createElement("div", {
    className: "uniques"
  }, /*#__PURE__*/React.createElement("div", {
    className: "unique"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-3 float-start align-middle",
    icon: "fa-solid fa-pencil"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-unique-1"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "unique"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-3 float-start align-middle",
    icon: "fa-solid fa-chart-line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-unique-2"
  }))));
};
export default DigitalEditingUniques;